import React from "react"

import "./StatuteBelt.css"
import StatutePin from "./StatutePin/StatutePin";

const StatuteBelt = () => {

	return (
		<div className="statuteBeltContainer">
			<StatutePin text="Junior"/>
			<StatutePin text="Junior"/>
			<StatutePin text="Junior"/>
			<StatutePin text="Junior"/>
		</div>
	);
}

export default StatuteBelt;